import { useState } from 'react';
import type { WriteInRequest } from '@signalvote/shared';
import { Button } from '@/components/ui';
import { stateName } from './raceStages';

// WriteIn.MaxName and WriteIn.MaxSeats on the server, which refuses past them.
const MAX_NAME = 200;
const MAX_SEATS = 99;

/** A race the catalog doesn't list in `state`, as the candidate describes it. Its numbers come next, in the calculator. */
export function WriteInForm({ state, initial, pending, onSubmit }: { state: string; initial?: WriteInRequest | null; pending?: boolean; onSubmit: (writeIn: WriteInRequest) => void }) {
  const [name, setName] = useState(initial?.name ?? '');
  const [electionDate, setElectionDate] = useState(initial?.electionDate ?? '');
  const [seats, setSeats] = useState(String(initial?.seats ?? 1));
  const seatCount = Number(seats);
  const valid = name.trim().length > 0 && !!electionDate && Number.isInteger(seatCount) && seatCount >= 1 && seatCount <= MAX_SEATS;
  const field = 'w-full rounded-lg border border-input bg-background px-3 py-2 text-foreground focus:outline-none focus:ring-2 focus:ring-ring';

  return (
    <div className="space-y-4 rounded-lg border p-4">
      <p className="text-sm font-medium">
        Tell us about your race in {stateName(state)}. You’ll type last time’s numbers next.
      </p>
      <label className="block space-y-1 text-sm font-medium">
        <span>Race name</span>
        <input className={field} value={name} maxLength={MAX_NAME} placeholder="Like “Lakewood City Council”" onChange={(e) => setName(e.target.value)} />
      </label>
      <div className="grid gap-3 sm:grid-cols-2">
        <label className="block space-y-1 text-sm font-medium">
          <span>Election day</span>
          <input type="date" className={field} value={electionDate} onChange={(e) => setElectionDate(e.target.value)} />
        </label>
        <div className="space-y-1">
          <label className="block space-y-1 text-sm font-medium">
            <span>How many winners? (seats up)</span>
            <input inputMode="numeric" className={field} value={seats} aria-describedby="write-in-seats-hint" onChange={(e) => setSeats(e.target.value)} />
          </label>
          <p id="write-in-seats-hint" className="text-xs text-muted-foreground">
            Usually 1.
          </p>
        </div>
      </div>
      <Button type="button" disabled={!valid || pending} onClick={() => onSubmit({ state, name: name.trim(), electionDate, seats: seatCount })}>
        Use this race
      </Button>
    </div>
  );
}
